import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import {CommonModal, FormErrors} from 'components/common';
import AssignableSubscriptionTable from './AssignableSubscriptionTable';
import AssignSubscriptionForm from './AssignSubscriptionForm';
import {
  fetchPendingSubscriptions,
  setCurrentPendingSubscriptionPage,
  clearPendingSubscriptionsAfterPage,
} from 'actions/subscriptions';
import {formatErrors} from 'actions/errors';
import {addFlashMessage} from 'actions/flash-message';
import {assignSubscription} from 'api/subscriptions';

class AssignableSubscriptionList extends React.Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {
      modalShown: false,
      currentSubscription: null,
      errors: {},
      tableKey: 0,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleAssign = this.handleAssign.bind(this);
  }

  showModal(currentSubscription) {
    this.setState({
      modalShown: true,
      currentSubscription,
    });
  }

  closeModal() {
    this.setState({
      modalShown: false,
    });
  }

  handleAssign(data) {
    const {currentSubscription} = this.state;
    const {formatErrors, addFlashMessage} = this.props;
    return assignSubscription({
      subscriptionId: currentSubscription.id,
      userId: data.reader.id,
    })
      .then(() => {
        this.setState((prevState) => ({
          modalShown: false,
          currentSubscription: null,
          tableKey: prevState.tableKey + 1,
        }));
        addFlashMessage('Subscription has been successfully created!', 'success');
      })
      .catch((err) =>
        formatErrors(err).then((err) => {
          this.setState({
            errors: err,
          });
        }),
      );
  }

  render() {
    const {modalShown, tableKey, errors} = this.state;
    const {
      pendingSubscriptionPages,
      fetchPendingSubscriptions,
      setCurrentPendingSubscriptionPage,
      clearPendingSubscriptionsAfterPage,
    } = this.props;
    return (
      <div className="container content-box">
        <Panel>
          <CommonModal title="Assign Subscription" onClose={this.closeModal} show={modalShown}>
            <FormErrors errors={errors} />
            <AssignSubscriptionForm onSubmit={this.handleAssign} />
          </CommonModal>
          <h3 className="section-header">
            <div className="section-title">Assignable Subscriptions</div>
          </h3>
          <AssignableSubscriptionTable
            {...{
              key: tableKey,
              recordPages: pendingSubscriptionPages,
              fetchRecords: (q, page, perPage, sortOpts, extraFilters = {}) =>
                fetchPendingSubscriptions(q, page, perPage, sortOpts, {
                  ...extraFilters,
                  summary: true,
                  assignable: true,
                }),
              setCurrentRecordPage: setCurrentPendingSubscriptionPage,
              clearRecordsAfterPage: clearPendingSubscriptionsAfterPage,
              showAssigningModal: this.showModal,
            }}
          />
        </Panel>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  pendingSubscriptionPages: state.subscriptions.get('pendingSubscriptionPages').toJS(),
});

const mapDispatchToProps = (dispatch) => ({
  formatErrors: (...args) => dispatch(formatErrors(...args)),
  addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
  fetchPendingSubscriptions: (...args) => dispatch(fetchPendingSubscriptions(...args)),
  setCurrentPendingSubscriptionPage: (...args) => dispatch(setCurrentPendingSubscriptionPage(...args)),
  clearPendingSubscriptionsAfterPage: (...args) => dispatch(clearPendingSubscriptionsAfterPage(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AssignableSubscriptionList);
